var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33329 6.25C6.02079 6.25 4.16663 8.10417 4.16663 10.4167V31.25C4.16663 32.3551 4.60561 33.4149 5.38701 34.1963C6.16842 34.9777 7.22822 35.4167 8.33329 35.4167H25V45.8333L31.25 39.5833L37.5 45.8333V35.4167H41.6666C42.7717 35.4167 43.8315 34.9777 44.6129 34.1963C45.3943 33.4149 45.8333 32.3551 45.8333 31.25V10.4167C45.8333 9.3116 45.3943 8.25179 44.6129 7.47039C43.8315 6.68899 42.7717 6.25 41.6666 6.25H8.33329ZM25 10.4167L31.25 14.5833L37.5 10.4167V17.7083L43.75 20.8333L37.5 23.9583V31.25L31.25 27.0833L25 31.25V23.9583L18.75 20.8333L25 17.7083V10.4167ZM8.33329 10.4167H18.75V14.5833H8.33329V10.4167ZM8.33329 18.75H14.5833V22.9167H8.33329V18.75ZM8.33329 27.0833H18.75V31.25H8.33329V27.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.670f0f8bfd778468953e38f619e089e6.svg";
export { ForwardRef as ReactComponent };